export default {
  documents: {
    lastUpdate: null,
    loading: false,
    data: [],
  },
  documentsByClient: {
    data: {},
    loading: {},
    lastUpdate: {},
  },
  templates: {
    lastUpdate: null,
    loading: false,
    data: [],
  },
  signers: {
    lastUpdate: null,
    loading: false,
    data: [],
    dataFiltered: [],
  },
  variables: {
    lastUpdate: null,
    loading: false,
    data: [],
  },
  roles: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  systemVariables: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  variablesOptions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // {{NEXT}}
}
